import ScreenLock from "../__constants/lock-screen";
import buttonFullpageContent from './menu-food/button-fullpage-content';
class Menu {
    constructor(hamburger, headerMain, menuNav) {
        this.hamburger = hamburger;
        this.headerMain = headerMain;
        this.menuNav = menuNav;
    }
    toggleMenu(e) {
        const target = e.currentTarget;
        const headerMain = document.querySelector(this.headerMain);
        const hamburger = document.querySelector(this.hamburger);
        const hamburgerBar = hamburger.parentNode;

        if (target.classList.contains("is-active")) {
            target.classList.remove("is-active");
            headerMain.classList.remove("is-active");
            hamburgerBar.classList.remove("is-active");
            ScreenLock.unlock();
        } else {
            target.classList.add("is-active");
            headerMain.classList.add("is-active");
            ScreenLock.lock();
        }
    }
    init() {
        const hamburger = document.querySelector(this.hamburger);
        const menuNav = document.querySelector(this.menuNav);
        hamburger.addEventListener("click", e => {
            const headerMain = document.querySelector(this.headerMain);
            if( !headerMain.classList.contains('increase-index') ){
                this.toggleMenu(e);
            } else {
                buttonFullpageContent.closeContent();
            }
        });
        menuNav.addEventListener("scroll", e => {
            const hamburgerBar = hamburger.parentNode;
            hamburgerBar.classList.add("is-active");
        });
    }
}

export default new Menu(".btn-hamburger", ".header-main", ".menu-container nav");
